import Big from "big.js";

export const Helper = {
    isAccountNegated: type => {
        switch (type) {
            case 'current_assets':
            case 'non_current_assets':
            case 'other_assets':
            case 'cost_of_sales':
            case 'expenses':
                return true;
            default:
                return false;
        }
    },

    getDefault: (record, dataIndex) => {
        switch (dataIndex) {
            case "form_amount":
            case "amount":
                return Helper.getDefaultAmount(record);
            case "debit":
                return Helper.getDefaultDebit(record);
            case "credit":
                return Helper.getDefaultCredit(record);
            default:
                return null;
        }
    },

    getDefaultBase: (record, dataIndex) => {
        switch (dataIndex) {
            case "form_amount":
            case "amount":
                return Helper.getDefaultBaseAmount(record);
            case "debit":
                return Helper.getDefaultBaseDebit(record);
            case "credit":
                return Helper.getDefaultBaseCredit(record);
            default:
                return null;
        }
    },

    getDefaultAmount: record => {
        //
        let amountB = new Big(record.amount);
        if (Helper.isAccountNegated(record.type))
            amountB = amountB.times(-1);
        return amountB.toFixed(2);
    },

    getDefaultBaseAmount: record => {
        const exchangeRateB = new Big(record.exchange_rate || 1);
        let amountB = new Big(record.amount);
        if (Helper.isAccountNegated(record.type))
            amountB = amountB.times(-1);
        return amountB.times(exchangeRateB).toFixed(2);
    },

    getDefaultDebit: record => {
        const amountB = new Big(record.amount);
        if (amountB.gte(0)) // Credit
            return "0.00";
        return amountB.abs().toFixed(2);
    },

    getDefaultBaseDebit: record => {
        const exchangeRateB = new Big(record.exchange_rate || 1);
        const amountB = new Big(record.amount);
        if (amountB.gte(0)) // Credit
            return "0.00";
        return amountB.abs().times(exchangeRateB).toFixed(2);
    },

    getDefaultCredit: record => {
        const amountB = new Big(record.amount);
        if (amountB.gte(0)) // Credit
            return amountB.toFixed(2);
        return "0.00";
    },

    getDefaultBaseCredit: record => {
        const exchangeRateB = new Big(record.exchange_rate || 1);
        const amountB = new Big(record.amount);
        if (amountB.gte(0)) // Credit
            return amountB.times(exchangeRateB).toFixed(2);
        return "0.00";
    },

    getDefaultExchangeRate: record => record.exchange_rate,
};
